import React from "react";
// Components
import DistributorValidation from "../../config/distributorValidation";
import BudgetGenerator from "../../components/budgetGenerator";

const BudgetGeneratorView = () => (
  <>
    {DistributorValidation()}
    <BudgetGenerator />
  </>
);

export default BudgetGeneratorView;
